<template>
  <div class="complete">
    <h1>Oops!</h1>
    <p>
      You did not finish your payment, please try again.
    </p>
  </div>
</template>

<script>
export default {
  name: 'Complete'
}
</script>

<style lang="scss" scoped>
  .complete {
    text-align: center;
    padding-top: 100px;
  }
</style>